// Stage 1A — mirrors backend app/services/measure_type.py (fixed, documented map).
export const KNOWN_BASES = ['ml', 'cl', 'l', 'g', 'kg', 'each'];

export function measureTypeOf(base) {
  const b = String(base || '').trim().toLowerCase();
  if (['ml', 'cl', 'l'].includes(b)) return 'volume';
  if (['g', 'kg'].includes(b)) return 'mass';
  if (['each', 'packet', 'pack'].includes(b)) return 'count';
  return 'unknown';
}
